import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';

const JWT_TOKEN_KEY = 'jwtToken';

type BrandTenant = {
  name?: string | null;
  fantasyName?: string | null;
};

function tenantFromStorage(): BrandTenant | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const token = localStorage.getItem(JWT_TOKEN_KEY);
  if (!token) {
    return undefined;
  }

  try {
    const payloadEncoded = token.split('.')[1];
    if (!payloadEncoded) {
      return undefined;
    }

    const payload = JSON.parse(
      atob(payloadEncoded.replace(/-/g, '+').replace(/_/g, '/'))
    );

    if (!payload.tenant) {
      return undefined;
    }

    return typeof payload.tenant === 'string'
      ? JSON.parse(payload.tenant)
      : payload.tenant;
  } catch {
    return undefined;
  }
}

export function getBrand(tenant?: BrandTenant) {
  return (
    tenant?.name ||
    tenant?.fantasyName ||
    import.meta.env.VITE_APP_NAME ||
    'Distributify'
  );
}

export function pageTitle(page: string) {
  return {
    meta: [{ title: `${page} | ${getBrand(tenantFromStorage())}` }],
  };
}

export function usePageTitle(section: string, name?: string | null) {
  const { tenant } = useAuth();

  useEffect(() => {
    const page = name?.trim() || section;
    document.title = `${page} | ${getBrand(tenant)}`;

    return () => {
      document.title = `${section} | ${getBrand(tenant)}`;
    };
  }, [section, name, tenant]);
}
